export function generateDashedBorderStyle(options: {
  dashLength?: number;
  dashGap?: number;
  color?: string;
  borderRadius?: number;
  strokeWidth?: number;
}) {
  const { dashLength = 8, dashGap = 8, color = '#E5E6E6', borderRadius = 4, strokeWidth = 1 } = options;

  const svg = `data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='${encodeURIComponent(color)}' stroke-width='${strokeWidth}' stroke-dasharray='${dashLength},${dashGap}' rx='${borderRadius}'/%3e%3c/svg%3e`;

  // Generate a unique class name including stroke width
  const className = `dashed-border-${dashLength}-${dashGap}-${color.replace('#', '')}-${borderRadius}-${strokeWidth}`;

  // Inject CSS into the document
  if (typeof document !== 'undefined') {
    const existingStyle = document.getElementById(className);
    if (!existingStyle) {
      const style = document.createElement('style');
      style.id = className;
      style.textContent = `
        .${className} {
          position: relative;
          border-radius: ${borderRadius}px;
          background: white;
        }
        .${className}::before {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: inherit;
          background-image: url("${svg}");
          pointer-events: none;
        }
      `;
      document.head.appendChild(style);
    }
  }

  return className;
}
